import { ValidateStepFxn } from 'common.types'

const voterRegistrationStepValidate: ValidateStepFxn = (step, state) => {
  if (step === 2) {
    const {
      reasonNewRegistration,
      reasonChangeRegistration,
      reasonChangeOfName,
      reasonChangeOfAddress,
      reasonChangeOfParty,
      reasonGovtEmployee,
    } = state
    if (
      !reasonGovtEmployee &&
      !reasonNewRegistration &&
      !reasonChangeRegistration
    ) {
      alert(
        'You must select either New Registration, Change Registration, or Federal or State employee.',
      )
      return false
    }
    if (reasonChangeRegistration) {
      if (
        !reasonChangeOfName &&
        !reasonChangeOfAddress &&
        !reasonChangeOfParty
      ) {
        alert('You must select a reason you are updating your registration.')
        return false
      }
    }
  }
  if (step === 5) {
    const { idCardNumber, ssnLastFour, noId } = state
    if (
      (!idCardNumber && !ssnLastFour && !noId) ||
      (idCardNumber && ssnLastFour) ||
      (idCardNumber && noId) ||
      (ssnLastFour && noId)
    ) {
      alert(
        'You must respond to one of the following: "PA driver\'s license or PennDOT ID card number", "Last 4 SSN Digits", "I  do not have a PA driver’s license or a PennDOT ID card or a Social Security number"',
      )
      return false
    }
  }

  return true
}

export default voterRegistrationStepValidate
